import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-material-calendar',
  templateUrl: './material-calendar.component.html',
  styleUrls: ['./material-calendar.component.scss'],
})
export class MaterialCalendarComponent implements OnInit  {
  @Input() minYear: number = 2010; // Default minimum year
  @Input() maxYear: number = new Date().getFullYear() + 10; // Default maximum year
  @Input() selectedYear: number = new Date().getFullYear(); // Selected year input
  @Input() disabledYears: number[] = []; // Years to disable
  @Output() yearSelected = new EventEmitter<number>(); // Emit selected year

  startYear!: number;
  endYear!: number;
  years: number[] = [];
  isDropdownOpen: boolean = false;

  ngOnInit() {
    this.startYear= this.selectedYear-1
    this.endYear = this.startYear + 11; // Show 12 years
    this.calculateYears();
  }

  calculateYears() {
    
    this.years = [];
    for (let i = this.startYear; i <= this.endYear; i++) {
      this.years.push(i);
    }
  }

  prevDecade() {
    // debugger
    this.startYear -= 10;
    this.endYear -= 10;

    if (this.startYear < this.minYear) {
      this.startYear = this.minYear;
      this.endYear = this.minYear + 11; // Show 12 years
    }

    this.calculateYears();
  }

  nextDecade() {
    // debugger
    this.startYear += 10;
    this.endYear += 10;

    if (this.endYear > this.maxYear) {
      this.endYear = this.maxYear;
      this.startYear = this.maxYear - 11; // Show 12 years
    }

    this.calculateYears();
  }

  selectYear(year: number) {
    if (!this.disabledYears.includes(year)) {
      this.selectedYear = year;
      this.yearSelected.emit(year); // Emit the selected year
      this.isDropdownOpen = false;
    }
  }

  prevYear() {
      if (this.selectedYear > this.minYear) {
        this.selectedYear--;
        this.yearSelected.emit(this.selectedYear);
      }
  }

  nextYear() {
      if (this.selectedYear < this.maxYear) {
        this.selectedYear++;
        this.yearSelected.emit(this.selectedYear);
      }
  }

  isYearDisabled(year: number): boolean {
    if (year < this.minYear || year > this.maxYear) {
      return true;
    }
    if (this.disabledYears.includes(year)) {
      return true;
    }
    return false;
  }
}